import Link from "next/link";
import "./style.css";
import 'lazysizes';
import { useEffect } from "react";
import Image from "next/image";


const customLoader = (src: string) => {
  return src; 
};
export default function BlogTile({
  index,
  title,
  blogImage,
  desc,
  isAiGenerated,
  date,
  aow,
  tech,
  url,
  carousel = false,
}: any) {
  const newDate = new Date(date);
  const formattedDate = newDate.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const isValidUrl = (url:any) => {
    try {
      new URL(url); 
      return true;  // ✅ URL is valid
    } catch (error) {
      return false; // ❌ Invalid URL
    }
  };
  
let finalImageUrl='https://d60jxomgr6xep.cloudfront.net/oodles-files/placeholderImg.webp?width=350px';

  if(blogImage!=null && isValidUrl(blogImage)) {
  const baseImageUrl = blogImage;
  const imageUrl = new URL(baseImageUrl);
  const imgData = new URLSearchParams(imageUrl.search);
   imgData.set("width", "350");
   imgData.set("format", "webp");
  finalImageUrl = `${imageUrl.origin}${imageUrl.pathname}?${imgData.toString()}`;
  }
  
  // blogImage !==null ? finalImageUrl : 'https://d60jxomgr6xep.cloudfront.net/oodles-files/placeholderImg.webp?width=350px'


  useEffect(() => {
    if (index === 0 && blogImage) {  // Preload only the first image for better LCP
      const existingPreload = document.querySelector(`link[href="${blogImage}?width=400&format=webp"]`);
      if (!existingPreload) {  // Prevent duplicate preload tags
        const preloadLink = document.createElement("link");
        preloadLink.rel = "preload";
        preloadLink.as = "image";
        preloadLink.href = `${blogImage}?width=400&format=webp`;
        preloadLink.type = "image/webp";
        preloadLink.setAttribute("fetchpriority", "high");
        document.head.appendChild(preloadLink);
      }
    }
  }, [blogImage, index]);
  
  return (
    <>
      <div className={`${carousel ? "mr-8" : ""}`}>
        <div className="overflow-hidden cursor-pointer">
          <Link
            href={`/insights/${url.replaceAll(" ","-").replace(/ |\u00A0|%C2%A0/g,'-')}`}
            className={` flex flex-col gap-2 overflow-hidden ${
              carousel ? "carouselBlog" : "wdithBlog "
            }`}
            onClick={()=>{window.scroll(0,0)}}
          >
            <div className="overflow-hidden rounded-xl imageHeight relative">
              <Image
              loader={() => customLoader(finalImageUrl)}
                alt="Blog Image"
                height="300"
                width="500"
                className="blogImage rounded-xl "
                src={finalImageUrl}
                onError={() => {}}
              />
              
              {
              isAiGenerated && (
                <div className="aiGen">
                  AI Generated
                </div>
                )
              }
            </div>
            <div className="text-gray-500 text-[0.7rem]">{formattedDate}</div>
            <div className="font-bold h-12 text-[0.95rem]">{title}</div>
            <div className="text-[0.8rem] text-gray-500 h-14 line-clamp-3">
              {desc}
            </div>
            <div className="flex my-2 gap-2 flex-col h-20">
              {aow != "" ? (
                <div className="flex gap-1 items-start bg-[#EFF6FC] p-2 rounded-2xl w-fit">
                  <div className="font-bold text-xs whitespace-nowrap">Area Of Expertise:</div>
                  <div className="text-[#2F83C5] text-xs" title={aow.join(", ")}>
                    {aow[0] +
                      (aow.length > 1 ? ", " + aow[1] : "") +
                      (aow.length > 2 ? " +" + (aow.length - 2) + " more" : "")}
                  </div>
                </div>
              ) : (
                ""
              )}

              {tech.length != 0 ? (
                <div className="flex gap-1 bg-[#EFF6FC] p-2 rounded-2xl w-fit">
                  <div className="font-bold text-xs">Technology:</div>
                  <div className="text-[#2F83C5] text-xs" title={tech.join(", ")}>
                    {tech[0] +
                      (tech.length > 1 ? ", " + tech[1] : "") +
                      (tech.length > 2
                        ? " +" + (tech.length - 2) + " more"
                        : "")}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}
